import { useCallback } from 'react';
import { useControlledState } from '../useControlledState';

export type UseControlledOpen = (params: {
  controlledOpen?: boolean;
  onOpenChange?: (value: boolean) => void;
}) => {
  isOpen: boolean;
  setIsOpen: (newOpen: boolean) => void;
};

/**
 * Manages the open/closed state of a component.
 */
export const useControlledOpen: UseControlledOpen = ({
  controlledOpen,
  onOpenChange,
}) => {
  const { value: isOpen, setValue: setInternalOpen } = useControlledState(
    controlledOpen,
    false
  );

  const setIsOpen = useCallback(
    (newOpen: boolean) => {
      setInternalOpen(newOpen);
      onOpenChange?.(newOpen);
    },
    [setInternalOpen, onOpenChange]
  );

  return {
    isOpen,
    setIsOpen,
  };
};
